import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Redirect, Route, Switch } from 'react-router-dom'
import { App } from '../common/App'
import { SharedCookieConsent } from '../common/cookies/SharedCookieConsent'
import { SiteTitleContext } from '../common/DocumentTitle'
import { useScrollToTop } from '../common/ui/useScrollToTop'
import { P2IA_APP_URL } from '../external-links'
import { Header } from '../header'
import { Home } from '../home'
import { Resources } from '../resources'
import { EfficacityStudyBanner } from './efficacity-study'
import { LearnMore } from './learn-more'
import { Metadata } from './metadata'
import { PricingPage } from './pricing'
import { RequestAQuote } from './request-a-quote'
import {
  LEARN_MORE_PATH,
  P2IA_PATH,
  PRICING_PATH,
  REQUEST_A_QUOTE_PATH,
  RESOURCES_PATH,
  TEAM_PATH,
} from './routes'
import { Team } from './team'
import { TNEBanner } from './tne'

export const Landing: React.FC = () => {
  const [t] = useTranslation('meta')
  return (
    <App>
      <TNEBanner />
      <EfficacityStudyBanner />
      <RunHook />
      <Metadata />
      <Header />
      <SharedCookieConsent />
      <SiteTitleContext.Provider value={{ siteTitlePrefix: t('title') }}>
        <Switch>
          <Route path="/" exact>
            <Home />
          </Route>
          <Route path={RESOURCES_PATH} exact>
            <Resources />
          </Route>
          <Route path="/piia" exact>
            <P2IARedirect />
          </Route>
          <Route path={P2IA_PATH} exact>
            <P2IARedirect />
          </Route>
          <Route path={TEAM_PATH}>
            <Team />
          </Route>
          <Route path={PRICING_PATH}>
            <PricingPage />
          </Route>
          <Route path={`${LEARN_MORE_PATH}.html`}>
            <LearnMore />
          </Route>
          <Route path={LEARN_MORE_PATH}>
            <LearnMore />
          </Route>
          <Route path={REQUEST_A_QUOTE_PATH}>
            <RequestAQuote />
          </Route>
          <Redirect to="/" />
        </Switch>
      </SiteTitleContext.Provider>
    </App>
  )
}

const P2IARedirect = () => {
  useEffect(() => {
    window.location.replace(P2IA_APP_URL)
  }, [])
  return null
}

const RunHook = () => {
  useScrollToTop()
  return null
}
